import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../components/mensajes2";
import { Dimmer } from "../../components/spinner";
import moment from "moment";

const ImpModalCajaCatastro = (props) => {
  let op = require("../../modulos/datos");
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idefiscal = localStorage.getItem("idefiscal");
  let fechainicio = new Date().getFullYear() + "-01-01";

  // Refs para elementos del DOM
  const check1 = useRef();
  const check2 = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();

  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [visible, setVisible] = useState("collapse");

  const blanquear = () => {
    setVisible("collapse");
    if (props.reporte === 1) {
      check1.current.checked = true;
      setActivate(false);
    }
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    blanquear();
    props.onHideCancelar();
  };

  const imprimir = () => {
    if (props.reporte === 1) {
      // REPORTE GENERAL
      const reporte = "ListGenCertificadoInmueble";
      let desde = "";
      let hasta = "";
      let sql2 = "";

      // Manejo de fechas
      if (check1.current?.checked) {
        // Hoy
        desde = moment.utc().format("DD-MM-YYYY");
        hasta = moment.utc().format("DD-MM-YYYY");
        sql2 = "Resumen del Día " + desde;
      } else {
        // Por fecha específica
        desde = moment.utc(txtDesde.current.value).format("DD-MM-YYYY");
        hasta = moment.utc(txtHasta.current.value).format("DD-MM-YYYY");

        if (
          Date.parse(txtDesde.current.value) ===
          Date.parse(txtHasta.current.value)
        ) {
          sql2 = "Resumen del Día " + desde;
        } else {
          sql2 =
            "DESDE EL " + "'" + desde + "'" + " HASTA EL " + "'" + hasta + "'";
        }
      }
      const CONDICION = `cxi.fechaemision >= to_date('${desde}', 'DD-MM-YYYY') AND cxi.fechaemision <= to_date('${hasta}', 'DD-MM-YYYY')`;
      // Abrir reporte general
      window.open(
        `${op.reportes}/catastro?reporte=${reporte}&CONDICION=${CONDICION}&TIT_RGO1=${sql2}&TIT_CRI1=Todas las cajas`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } else if (props.reporte === 2) {
      // REPORTE DETALLADO
      const reporte = "ListGenCedulaInmueble";
      let desde = "";
      let hasta = "";
      let sql2 = "";

      if (check1.current?.checked) {
        // Hoy
        desde = moment.utc().format("DD-MM-YYYY");
        hasta = moment.utc().format("DD-MM-YYYY");
        sql2 = "Resumen del Día " + desde;
      } else {
        // Por fecha específica
        desde = moment.utc(txtDesde.current.value).format("DD-MM-YYYY");
        hasta = moment.utc(txtHasta.current.value).format("DD-MM-YYYY");

        if (
          Date.parse(txtDesde.current.value) ===
          Date.parse(txtHasta.current.value)
        ) {
          sql2 = "Resumen del Día " + desde;
        } else {
          sql2 =
            "DESDE EL " + "'" + desde + "'" + " HASTA EL " + "'" + hasta + "'";
        }
      }
      const CONDICION = `cxi.fechaemision >= to_date('${desde}', 'DD-MM-YYYY') AND cxi.fechaemision <= to_date('${hasta}', 'DD-MM-YYYY')`;

      // Abrir reporte
      window.open(
        `${op.reportes}/catastro?reporte=${reporte}&CONDICION=${CONDICION}&TIT_RGO1=${sql2}&TIT_CRI1=Todas las cajas`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
  };

  const cambio = (e) => {
    if (e.target.name === "dia") {
      if (e.target.value === "0") {
        // Hoy
        setVisible("collapse");
      } else if (e.target.value === "1") {
        // Por Fecha
        setVisible("visible");
      }
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        // Inicialización al mostrar el modal
        if (props.reporte === 2) {
          setVisible("visible");
          //fechainicio = new Date().getFullYear() + "/01/01";
        } else {
          //fechainicio = fechasistema;
        }
      }}
    >
      <Modal.Header className="azulGradiant">
        <div className="fw-bold text-light">
          {props.reporte === 1
            ? "Listado General de Impresion de Certificados de Empadronamiento"
            : "Listado General de Cédulas Catastrales"}
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-md-12 row mx-auto">
          <fieldset className="row col-md-12 border-azul rounded mx-auto">
            <legend className="float-none m-0 w-auto">Rango de Fecha</legend>
            {props.reporte === 1 ? (
              <div className="col-md-6 mb-2 row mx-auto">
                <div className="form-check my-auto col">
                  <input
                    className="form-check-input my-auto"
                    value={0}
                    type="radio"
                    onChange={cambio}
                    name="dia"
                    id="flexRadioDefault1"
                    ref={check1}
                    defaultChecked
                  />
                  <label
                    className="form-check-label my-auto"
                    for="flexRadioDefault1"
                  >
                    Hoy
                  </label>
                </div>
                <div className="form-check my-auto col">
                  <input
                    className="form-check-input my-auto"
                    value={1}
                    type="radio"
                    onChange={cambio}
                    name="dia"
                    id="flexRadioDefault2"
                    ref={check2}
                  />
                  <label
                    className="form-check-label my-auto"
                    for="flexRadioDefault2"
                  >
                    Por Fecha
                  </label>
                </div>
              </div>
            ) : (
              ""
            )}
            <div
              className="col-md-10 mx-auto row d-flex justify-content-between"
              style={{ visibility: visible }}
            >
              {props.reporte === 2 ? (
                <div className="input-group input-group-sm mb-3 col-md-2 mx-auto">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Fecha:
                  </span>
                </div>
              ) : (
                ""
              )}
              <div className="input-group input-group-sm mb-3 col-md-5 ">
                <span className="input-group-text" id="inputGroup-sizing-sm">
                  Desde:
                </span>
                <input
                  type="date"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  defaultValue={moment
                    .utc(props.reporte === 2 ? fechainicio : fechasistema)
                    .format("YYYY-MM-DD")}
                  max={moment.utc(fechasistema).format("YYYY/MM/DD")}
                  ref={txtDesde}
                />
              </div>
              <div className="input-group input-group-sm mb-3 col-md-5 ">
                <span className="input-group-text" id="inputGroup-sizing-sm">
                  Hasta:
                </span>
                <input
                  type="date"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
                  max={moment.utc(fechasistema).format("YYYY/MM/DD")}
                  ref={txtHasta}
                />
              </div>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-primary rounded-pill"
          style={{ margin: "5px" }}
          onClick={imprimir}
        >
          <i className="fas fa-print"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImpModalCajaCatastro;
